/**************************************************
 * Nombre:       Seccion_Habitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Reserva from "../Dialogos/Reservas/Dialogo_Reserva";
import React, {useContext, useEffect, useRef, useState} from "react";
import {
    Add,
    AddBoxOutlined,
    AssignmentInd,
    AssignmentReturn,
    CleaningServicesOutlined,
    IndeterminateCheckBoxOutlined,
    ManageSearch,
    PointOfSaleSharp
} from '@mui/icons-material'
import Visualizador_Habitaciones from "../../Modulo_Motor_Reservas/Componentes/Visualizador_Habitaciones";
import {obtenerHabitaciones} from "../../Modulo_Motor_Reservas/Controladores/obtenerHabitaciones";
import {obtenerReservasDia} from "../../Modulo_Motor_Reservas/Controladores/obtenerReservasDia";
import {useMenuPop} from "../../Modulo_Menu_Pop/Hooks/useMenuPop";
import Dialogo_Abonos from "../Dialogos/Reservas/Dialogo_Abonos";
import Dialogo_CheckIn from "../Dialogos/Reservas/Dialogo_CheckIn";
import Dialogo_CheckOut from "../Dialogos/Reservas/Dialogo_CheckOut";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import Dialogo_Adicionales from "../Dialogos/Reservas/Dialogo_Adicionales";
import Dialogo_Descuentos from "../Dialogos/Reservas/Dialogo_Descuentos";
import Titulo_Dos_Datos from "../../Modulo_Graficas/Componentes/Titulos/Titulo_Dos_Datos";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import ic_caja from "../../Modulo_Graficas/RecursosGraficas/ic_caja.svg";
import {formatoMonedaGraficasDisminuido} from "../../Modulo_Graficas/Utilidades/formatoMonedaGraficasDisminuido";
import ic_cartera from "../../Modulo_Graficas/RecursosGraficas/ic_cartera.svg";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import {METODOBONO, TIPOMOVIMIENTO} from "../../Constantes";
import {contarWheresSuma} from "../../Servicios/BD/Contadores/contarWheresSuma";
import {obtenerOcupacionEntreFechas} from "../../Modulo_Motor_Reservas/Controladores/obtenerOcupacionEntreFechas";
import {
    obtenerDiasDisponiblesHabitaciones
} from "../../Modulo_Motor_Reservas/Funciones/obtenerDiasDisponiblesHabitaciones";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {obtenerValorTotal, totalArr} from "../Utilidades/obtenerValorTotal";

const Seccion_Habitaciones = () => {
    const {sCell} = useResponsive()
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [totalCaja, setTotalCaja] = useState([])
    const [ocupacionHoy, setOcupacionHoy] = useState(0)
    const [ocupacionMes, setOcupacionMes] = useState(0)
    const [recaudoPotencial, setRecaudoPotencial] = useState(0)
    const usuario = useContext(usuarioContext).usuario
    const [habitaciones, setHabitaciones] = useState([])
    const [reservas, setReservas] = useState([])
    const {MenuPop, abrirMenu} = useMenuPop()
    const [cargar, setCargar] = useState(false)
    const cargarNuevamente = () => {
        setCargar(!cargar)
    }
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Reserva,
        titulo: 'Detalles del reserva',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoAdicionales, abrir: abrirAdicionales} = useDialogo({
        Componente: Dialogo_Adicionales,
        titulo: 'Detalles de adicionales',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoDescuentos, abrir: abrirDescuentos} = useDialogo({
        Componente: Dialogo_Descuentos,
        titulo: 'Detalles de descuentos',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoAbono, abrir: abrirAbono} = useDialogo({
        Componente: Dialogo_Abonos,
        titulo: 'Detalles de abonos',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoCheckIn, abrir: abrirChechIn} = useDialogo({
        Componente: Dialogo_CheckIn,
        titulo: 'Detalles de CheckIn',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoCheckOut, abrir: abrirChechOut} = useDialogo({
        Componente: Dialogo_CheckOut,
        titulo: 'Detalles de CheckOut',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'adicionales':
                abrirAdicionales(data)
                break
            case 'descuentos':
                abrirDescuentos(data)
                break
            case 'abonos':
                abrirAbono(data)
                break
            case 'checkIn':
                abrirChechIn(data)
                break
            case 'checkOut':
                abrirChechOut(data)
                break
            case 'limpiar':
                limipiar(data)
                break
            default :
                abrir(data)

        }
    }

    const obtenerDatos = async () => {

        let wIngresos = [where('tipo', '==', TIPOMOVIMIENTO[0].nombre), where('metodo', '==', METODOBONO[0])]
        let wEgresos = [where('tipo', '==', TIPOMOVIMIENTO[1].nombre)]

        let ingresos = await contarWheresSuma({coleccion: 'cajaMovimientos', propiedad: 'valor', wheres: wIngresos})
        let egresos = await contarWheresSuma({coleccion: 'cajaMovimientos', propiedad: 'valor', wheres: wEgresos})

        setTotalCaja(ingresos.data - egresos.data)


        let reservasCompletaDia = await obtenerReservasDia({fechaDia: new Date().getTime()})
        let recaudo = obtenerRecaudoPotencial(reservasCompletaDia)
        setRecaudoPotencial(recaudo)

        let arrHabitaciones = await obtenerHabitaciones()
        let diasDisponibles = obtenerDiasDisponiblesHabitaciones(arrHabitaciones)

        let fecha_ = new Date()
        let inicioMes = new Date(fecha_.getFullYear(), fecha_.getMonth(), 1, 0, 0, 1).getTime()
        let finMes = new Date(fecha_.getFullYear(), fecha_.getMonth() + 1, -1, 0, 0, 0).getTime()
        let reservasMes = await obtenerOcupacionEntreFechas({fechaInicio: inicioMes, fechaFin: finMes})

        let porcentaje = (reservasCompletaDia.length * 100) / arrHabitaciones.length
        setOcupacionHoy(porcentaje)


        let porcentajeMes = (reservasMes * 100) / diasDisponibles
        setOcupacionMes(porcentajeMes)


    }


    const obtenerRecaudoPotencial = (reservas) => {

        let val = 0
        for (let i = 0; i < reservas.length; i++) {
            let reserva = reservas[i]
            let total = obtenerValorTotal(reserva)
            let abonos = totalArr(reserva.abonos)
            val = val + (total - abonos)
        }

        return val
    }


    const limipiar = async (data) => {

        if (data.estado === 'Limpieza') {
            data.estado = 'Completada'
            let dox = await guardarDoc('reservas', data)
            cargarNuevamente()
        }

    }

    useEffect(() => {
        obtenerHabitaciones().then((dox) => {
            setHabitaciones(dox)
        })

        obtenerReservasDia({fechaDia: new Date().getTime()}).then((dox) => {
            setReservas(dox)
        })

        obtenerDatos()

    }, [cargar]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <MenuPop opciones={botonesData} click={click}/>

                <Dialogo/>

                <DialogoAdicionales/>

                <DialogoDescuentos/>

                <DialogoAbono/>

                <DialogoCheckIn/>

                <DialogoCheckOut/>


                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}
                      sx={{height: altoGraficas, mb: sCell ? 21 : 0}}>
                    <Titulo_Dos_Datos titulo={'Estado de Habitaciones'} usuario={usuario} textoUno={'Ocupacion Hoy'}
                                      textoDos={'Ocupacion Mes'}
                                      datoUno={ocupacionHoy.toFixed(2) + '%'}
                                      datoTres={ocupacionMes.toFixed(2) + '%'}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={ic_caja} titulo={'Total Caja'}
                                       valor={formatoMonedaGraficasDisminuido(totalCaja)}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={ic_cartera} color={'#7E7850'} titulo={'Recaudo Pot'}
                                       valor={formatoMonedaGraficasDisminuido(recaudoPotencial)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                    <Button

                        onClick={() => abrir()}
                        startIcon={<Add/>}>Agregar Reserva</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pb: 4}}>
                    <Visualizador_Habitaciones habitaciones={habitaciones} reservas={reservas}
                                               fechaEscogida={new Date().getTime()}
                                               click={abrirMenu}
                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Habitaciones


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Adicionales',
        id: 'adicionales',
        icono: AddBoxOutlined
    },
    {
        nombre: 'Descuentos',
        id: 'descuentos',
        icono: IndeterminateCheckBoxOutlined
    },
    {
        nombre: 'Abonos',
        id: 'abonos',
        icono: PointOfSaleSharp
    },
    {
        nombre: 'Check In',
        id: 'checkIn',
        icono: AssignmentInd
    },
    {
        nombre: 'Check Out',
        id: 'checkOut',
        icono: AssignmentReturn
    },
    {
        nombre: 'Limpiar',
        id: 'limpiar',
        icono: CleaningServicesOutlined
    },
]